import Axios, { AxiosInstance } from "axios";
import sessionProvider from "./../utils/session.js";

export interface IHttpClient {
  get(extra?: string): Promise<any>;
  getById(id: any): Promise<any>;
  post(data: any): Promise<any>;
  put(id: any, data: any): Promise<any>;
  remove(id: any): Promise<any>;
}

const session = sessionProvider.create(sessionStorage);

Axios.interceptors.request.use(
  function(config:any) {
    config.headers.common["authorization"] = "Bearer " + session.getToken() || "";
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    let title = "",
      message = "";

    if (error.response) {
      title = "ERROR SERVIDOR";
      message = error.response && error.response.data ? error.response.data : error.message;
    } else if (error.request) {
      title = "ERROR PETICIÓN";
      message = error.request && error.request.data ? error.request.data : error.message;
    } else {
      title = "ERROR";
      message = error ? error.message : "Se ha producido un error";
    }

    //Notifications.basic(title, message, { status: "error" });

    return Promise.reject(error);
  }
);

export class HttpClient implements IHttpClient {
  private endpoint: string;
  private slug: string;
  private client: AxiosInstance;

  constructor(endpoint: string, slug: string) {
    this.endpoint = endpoint;
    this.slug = slug;
    this.client = Axios;
  }

  private baseUrl(extra?: string) {
    if (extra !== undefined) {
      return `${this.endpoint}/${this.slug}${extra}`;
    }

    return `${this.endpoint}/${this.slug}`;
  }

  get(extra?: string): Promise<any> {
    return Axios.get(this.baseUrl(extra));
  }

  getById(id: any): Promise<any> {
    return Axios.get(`${this.endpoint}/${this.slug}/${id}`);
  }
  post(data: any, extra?: string): Promise<any> {
    return Axios.post(this.baseUrl(extra), data);
  }
  put(id: any, data: any, extra?: string): Promise<any> {
    return Axios.put(`${this.baseUrl(extra)}/${id}`, data);
  }
  remove(id: any, extra?: string): Promise<any> {
    return Axios.delete(`${this.baseUrl(extra)}/${id}`);
  }

  removeVarious(id: any, other:any, extra?: string): Promise<any> {
    return Axios.delete(`${this.baseUrl(extra)}/${id}/${other}`);
  }

  postFile(data: any, extra?: string): Promise<any> {
    return Axios.post(this.baseUrl(extra), data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }});
  }

  getFile(extra?: string): Promise<any> {
    return Axios.get(this.baseUrl(extra),{
      responseType: 'blob'
    });
  }

  postDownloadFile(data: any, extra?: string): Promise<any> {
    return Axios.post(this.baseUrl(extra), data, {
      responseType: 'blob'
    });
  }
}
